import React, { memo, VFC, useEffect, useRef, useState } from 'react';
import {
  Center,Spinner,Text,Flex,Box,Heading,
} from '@chakra-ui/react';
import { ErrorDialog } from '../organisms/modal/ErrorDialog';
import { useDashboard } from '../../hooks/useDashboard';
// import { useLoginUser } from "../../hooks/providers/useLoginUserProvider";
import { useOpelog } from '../../hooks/useOpelog';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';

export const Dashboard: VFC = memo(() => {
  const { GetDashboard, dashboardUrl, errObj, opeErrMes } = useDashboard();
  const { OutputOpelog } = useOpelog();
  // const { loginUser } = useLoginUser();
  const [ closeFlag, setCloseFlag ] = useState(false);
  const execFlag = useRef(true)
  
  // ダッシュボードURL取得
  useEffect(() => {
    if( execFlag.current ){
      GetDashboard();
      OutputOpelog( 'dashboard', 'reference', '');
    }
    execFlag.current = false;

  }, []);
  
  useEffect(() => {
    if( dashboardUrl ){
      // ダッシュボード埋込
      (async() => {
        const embeddingContext = await createEmbeddingContext();
        const {embedDashboard} = embeddingContext;
        
        const frameOptions = {
          url: dashboardUrl,
          container: '#experience-container',
          height: "1700px",
          width: "100%",
        };
        const contentOptions = {
          locale: "ja-JP",
        };
        
        await embedDashboard(frameOptions, contentOptions);
        // const embeddedDashboardExperience = await embedDashboard(frameOptions, contentOptions);
        // embeddedDashboardExperience.initiatePrint();
        
      })();
      
    }

  }, [dashboardUrl]);

  return (
    <>
    {(errObj || opeErrMes) && !closeFlag  ? (
      <ErrorDialog errTitle="その他関連情報の取得" errObj={errObj} opeErrMes={opeErrMes} setCloseFlag={setCloseFlag} />
      
    ) : (
      <Center>
        <Box
          w="100%"
          bg="white"
          shadow="md"
          marginTop="10px"
          marginRight="10px"
          borderRadius="10px"
        >
          <Flex>
            <Heading size="md" margin="10px">
              <Flex>■その他関連情報</Flex>
            </Heading> 
          </Flex>
          {dashboardUrl ? (
            <div id="experience-container"></div>
          ) : closeFlag ? (
            <Center h="50vh">
              <Text>ダッシュボードの表示に失敗しました</Text>
            </Center>
          ) : (
            <Center h="50vh">
              <Spinner color="teal.500" />
              <Text>その他関連情報準備中・・・</Text>
            </Center>
          )}
        </Box>
      </Center>
    )}
    </>
  );
});
